import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDFteHQKmq6I4JisMiJEoblEkkU0Uf7OzY",
  authDomain: "sorte-rapida.firebaseapp.com",
  projectId: "sorte-rapida",
  storageBucket: "sorte-rapida.appspot.com",
  messagingSenderId: "192207717623",
  appId: "1:192207717623:web:f2d55b8543ee3ad667fff2",
  measurementId: "G-HZLR82KBZR",
};

export const initializeFirebaseApp = async () => {
  const supported = await isSupported();
  if (supported) {
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    return messaging;
  } else {
    console.error("Firebase is not supported by this browser.");
    return null;
  }
};

export const getTokenFromVapid = async () => {
  const messaging = await initializeFirebaseApp();
  if (!messaging) return;

  if (messaging) {
    listenForMessages(messaging);
  }

  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BEpKynGKVFpbyg8N53c3l8QFvegFm_T_6oCbWl8lklVSmwRa15Fp3Yridvlf930onnIwi2HVBQUlw8jHApW-JfY",
    });
    if (currentToken) {
      return currentToken;
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
    }
  } catch (error) {
    console.error("An error occurred while retrieving token:", error);
  }
};

// Listen for messages when the app is in the foreground
export const listenForMessages = (messaging) => {
  onMessage(messaging, (payload) => {
    console.log("Message received. ", payload);
    // Customize notification here if needed
  });
};
